import { useMemo } from 'react';
import type { DeliveryType } from 'shared/src/api/goodsService/getGoodsOptions';
import { useIsBottomSheetGiftMode } from '../../hooks/useIsBottomSheetGiftMode';
import { useGetOrderDeadlineText } from '../../hooks/useGetOrderDeadlineText';
import { PricingTodayDeliveryBadge } from './PricingTodayDeliveryBadge';

export const PricingBadge = ({
  deliveryType,
  salesMethod,
}: {
  deliveryType: DeliveryType;
  salesMethod?: 'PRE_ORDER' | null;
}) => {
  const isGiftMode = useIsBottomSheetGiftMode();
  const isPreOrder = salesMethod === 'PRE_ORDER';

  const isTodayDelivery = useMemo(() => {
    if (isGiftMode) return false;

    return deliveryType === 'today' || deliveryType === 'shak';
  }, [deliveryType, isGiftMode]);

  const getDeadlineText = useGetOrderDeadlineText();

  const orderDeadline = useMemo(() => {
    if (!isTodayDelivery) return null;

    return getDeadlineText({ delivery_type: deliveryType });
  }, [isTodayDelivery, getDeadlineText, deliveryType]);

  if (isPreOrder) {
    return null;
  }

  if (isTodayDelivery) {
    return <PricingTodayDeliveryBadge orderDeadline={orderDeadline} />;
  }

  return null;
};
